import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ms from "../locales/ms.json";
import zh from "../locales/zh.json";

i18n.use(initReactI18next).init({
  resources: {
    ms: { translation: ms },
    zh: { translation: zh },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
